import store from '@/store'
import config from '@/config'
import lodash from 'lodash'
import BettingOffer from '@/components/mixins/BettingOffer'

export default {
  data () {
    return {
      periodicalRecommendedEventsTimeoutId: undefined,
      recommendedEventsBoNodeObject: {
        idfwbonavigation: 'recommended',
        displaytemplatename: config.app.autoconf.PLAYER_PERSONALISATION.eventGroupingForRecommendedEvents
      }
    }
  },

  computed: {
    isRootSportsNavigation () {
      return this.$route.name === 'sports'
    },
    isRecommendedEnabled () {
      return config.app.autoconf.PLAYER_PERSONALISATION.enableRecommendedEvents && this.isRootSportsNavigation
    },
    isRecommendedTabDefault () {
      return config.app.autoconf.PLAYER_PERSONALISATION.isRecommendedTabDefault
    },
    isRecommendedEventsVisible () {
      return this.isRecommendedEnabled
    },
    recommendedEventsIds () {
      return store.getters['recommendedState/getRecommendedEventIds']
    },
    recommendedEventsMarketGroup () {
      return store.getters['recommendedState/getRecommendedEventsMarketGroup']
    },
    recommendedEventsMarketGroupsBySport () {
      let marketGroups = []
      let eventsBySport = lodash.groupBy(this.recommendedEventsMarketGroup.events, 'idfosporttype')

      for (let key in eventsBySport) {
        let orderOfSport = null
        let sportOrderPriority = config.app.autoconf.PLAYER_PERSONALISATION.recommendedEventsOrderBySportPriority

        orderOfSport = sportOrderPriority.indexOf(key) + 1 // ordering to start with 1, 0 means not found in config

        marketGroups.push({
          order: orderOfSport || null,
          name: key,
          marketGroup: {
            marketgroupname: eventsBySport[key][0].fosporttypename,
            idfwmarketgroup: this.recommendedEventsMarketGroup.idfwmarketgroup || null,
            events: eventsBySport[key],
            idfwpopulationtype: 'NEXTOFFBYSPORTTYPEMKTTYPCLASSPER'
          }
        })
      }

      marketGroups = lodash.orderBy(marketGroups, 'order', 'asc')
      return marketGroups
    },
    boNavigation () {
      return store.getters['bonavigationState/boNavigation']
    },
    currentBoNavigation () {
      var idfwbonavigation = BettingOffer.computed.idfwbonavigation1 || BettingOffer.computed.idfwbonavigation2 || 'top'
      return (idfwbonavigation && this.boNavigation && this.boNavigation[idfwbonavigation]) || undefined
    },
    fallbackEventsMarketGroup () {
      const homeBoNode = this.currentBoNavigation &&
        this.currentBoNavigation.bonavigationnodes &&
        this.currentBoNavigation.bonavigationnodes.find(node =>
          node.idfwbonavigationtypes.includes('TABCONTAINER')
        )

      if (!homeBoNode || !homeBoNode.bonavigationnodes) return null

      const isInPlayBoNode = homeBoNode.bonavigationnodes.find(node =>
        !node.idfwbonavigationtypes.includes('INPLAYPERSPORTTYPE') &&
        Array.isArray(node.marketgroups) &&
        node.marketgroups.length > 0
      )

      if (!isInPlayBoNode || !Array.isArray(isInPlayBoNode.marketgroups)) return null

      const fallbackMGs = []
      let shouldShowLoading = false

      isInPlayBoNode.marketgroups.forEach(mg => {
        const id = mg.idfwmarketgroup
        const marketgroup = this.marketgroups[id]

        if (!marketgroup) {
          shouldShowLoading = true
          store.dispatch('marketgroupState/fetchMarketgroupById', id)
        } else {
          fallbackMGs.push({
            marketGroup: {
              events: marketgroup.events,
              idfwmarketgroup: marketgroup.idfwmarketgroup,
              marketgroupname: marketgroup.marketgroupname,
              idfwpopulationtype: marketgroup.idfwpopulationtype
            },
            name: marketgroup.marketgroupname
          })
        }
      })

      if (shouldShowLoading) {
        store.commit('recommendedState/setRecommendedEventsLoading', true)
        setTimeout(() => {
          store.commit('recommendedState/setRecommendedEventsLoading', false)
        }, 500)
      }

      return fallbackMGs.length > 0 ? fallbackMGs : null
    },
    recommendedEventsAvailablePrematchSports () {
      let sports = []

      const addUniqueSport = (id, name) => {
        if (id && name && !sports.some(sp => sp.idfosporttype === id)) {
          sports.push({
            idfosporttype: id,
            fosporttypename: name
          })
        }
      }

      if (this.recommendedEventsMarketGroup && this.recommendedEventsMarketGroup.events.length) {
        this.recommendedEventsMarketGroup.events.forEach(ev => {
          addUniqueSport(ev.idfosporttype, ev.fosporttypename)
        })
      } else if (Array.isArray(this.fallbackEventsMarketGroup)) {
        this.fallbackEventsMarketGroup.forEach(group => {
          if (group.marketGroup && Array.isArray(group.marketGroup.events)) {
            group.marketGroup.events.forEach(ev => {
              addUniqueSport(ev.idfosporttype, ev.fosporttypename)
            })
          }
        })
      }

      return sports
    },
    resetTimeoutIntervalOnLogin () {
      return store.getters['recommendedState/getResetTimeoutIntervalOnLogin']
    }
  },

  methods: {
    startRecommendedEventsUpdate () {
      // console.log('RECOMM - Start RecommendedEvents Update')
      let userId = (localStorage.customer === 'undefined' ? null : localStorage.customer)
      store.dispatch('recommendedState/fetchRecommendedEvents', userId).then(() => {
        clearTimeout(this.periodicalRecommendedEventsTimeoutId)
        this.periodicalRecommendedEventsTimeoutId = setTimeout(() => {
          this.startRecommendedEventsUpdate()
        }, config.app.autoconf.PLAYER_PERSONALISATION.periodicalUpdateRecommendedEvents)
      })
    },
    stopRecommendedEventsUpdate () {
      // console.log('RECOMM - Stop RecommendedEvents Update')
      clearTimeout(this.periodicalRecommendedEventsTimeoutId)
    },
    marketGroupNameBySport (event) {
      if (!event) return ''
      if (event.sportname && event.sportname.indexOf(event.fosporttypename) < 0) return `${event.fosporttypename} - ${event.sportname}`
      return event.sportname
    }
  },

  created () {
  },

  mounted () {
    if (this.isRecommendedEnabled) {
      // start fetching recommended events
      this.startRecommendedEventsUpdate()
    }
  },

  destroyed () {
    this.stopRecommendedEventsUpdate()
  },
  watch: {
    resetTimeoutIntervalOnLogin (newVal) {
      if (newVal && this.isRecommendedEnabled) {
        this.stopRecommendedEventsUpdate()
        this.startRecommendedEventsUpdate()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/RecommendedEvents.js